import MazSelect from "./_main.vue";

MazSelect.install = (Vue) => {
  Vue.component(MazSelect.name, MazSelect);
};

export default MazSelect;
